import { render, staticRenderFns } from "./PostTippingModal.vue?vue&type=template&id=19dd6def&scoped=true&"
import script from "./PostTippingModal.vue?vue&type=script&lang=ts&"
export * from "./PostTippingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PostTippingModal.vue?vue&type=style&index=0&id=19dd6def&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd6def",
  null
  
)

export default component.exports